import React, { forwardRef, useImperativeHandle, useRef } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import CustomerVerificationForm from '@/common/customer.verification/CustomerVerificationForm';

import ModalHeader from '../common/modal/header';

const CustomerVerificationModal = forwardRef(
    ({ onComplete, onCancel }, ref) => {
        const [t] = useTranslation('customer.verification');
        const customerVerificationFormRef = useRef(null);

        useImperativeHandle(
            ref,
            () => ({
                requestCode: () => {
                    customerVerificationFormRef.current.checkNumberAndRequestCode();
                },
            }),
            [customerVerificationFormRef]
        );

        return (
            <div className="m2g-customer-verification-modal">
                <ModalHeader headerText={t('title')} onClose={onCancel} />
                <CustomerVerificationForm
                    onComplete={onComplete}
                    ref={customerVerificationFormRef}
                />
            </div>
        );
    }
);

CustomerVerificationModal.propTypes = {
    onComplete: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
};

CustomerVerificationModal.displayName = 'CustomerVerificationModal';

export default CustomerVerificationModal;
